(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less", "../_util/date", "../address-picker", "../_mixins/picker", "../_mixins/osProps"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("../_util/date"), require("../address-picker"), require("../_mixins/picker"), require("../_mixins/osProps"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index, global.date, global.addressPicker, global.picker, global.osProps);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index, _date, _addressPicker, _picker, _osProps) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _addressPicker = _interopRequireDefault(_addressPicker);
  _picker = _interopRequireDefault(_picker);
  _osProps = _interopRequireDefault(_osProps);
  var _default2 = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "nx-time-picker"
      }, [_c('nx-address-picker', {
        attrs: {
          "value": _vm.value,
          "title": _vm.title,
          "describe": _vm.describe,
          "data": _vm.timeData,
          "selectedIndex": _vm.selectedIndex,
          "swipeTime": _vm.swipeTime,
          "hasMask": _vm.hasMask,
          "lockScroll": _vm.lockScroll,
          "maskClosable": _vm.maskClosable,
          "position": _vm.position,
          "transition": _vm.transition,
          "okText": _vm.okText,
          "cancelText": _vm.cancelText,
          "backClosePopupCustomEvent": _vm.backClosePopupCustomEvent,
          "slideDownDisappear": _vm.slideDownDisappear,
          "backClosePopup": _vm.backClosePopup,
          "isWebviewFull": _vm.isWebviewFull
        },
        on: {
          "input": _vm.$_onInput,
          "change": _vm._pickerChange,
          "confirm": _vm._pickerConfirm,
          "cancel": _vm._pickerCancel,
          "show": _vm.$_onShow,
          "hide": function hide($event) {
            return _vm.$emit('hide');
          }
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function fn(ref) {
            var pickerData = ref.pickerData;
            return _vm._l(pickerData, function (item) {
              return _c('div', {
                key: item.value,
                staticClass: "time-picker-item"
              }, [_c('span', {
                class: {
                  'time-picker-item-number': !!item.unit
                }
              }, [_vm._v(_vm._s(item.text))]), item.unit ? _c('span', {
                staticClass: "time-unit"
              }, [_vm._v(_vm._s(item.unit))]) : _vm._e()]);
            });
          }
        }])
      })], 1);
    },
    name: 'nx-time-picker',
    mixins: [_picker.default, _osProps.default],
    components: (0, _defineProperty2.default)({}, _addressPicker.default.name, _addressPicker.default),
    props: {
      date: Number,
      day: {
        type: Object,
        default: function _default() {}
      },
      minuteStep: {
        type: Number,
        default: 10
      },
      min: {
        type: [Date, Number],
        default: null
      },
      max: {
        type: [Date, Number],
        default: null
      },
      columnCount: {
        type: Number,
        default: 2
      },
      format: {
        type: String,
        default: 'YYYY/MM/DD hh'
      }
    },
    data: function data() {
      return {
        now: new Date(),
        timeValue: 0
      };
    },
    computed: {
      selectedIndex: function selectedIndex() {
        var value = this.date || this.timeValue;
        var minTime = this.minTime;
        var comparativeTime = this.min || this.min === 0 ? +minTime : Math.floor(minTime / _date.MINUTE_TIMESTAMP) * _date.MINUTE_TIMESTAMP;

        if (value < comparativeTime) {
          return new Array(this.columnCount).fill(0);
        } else {
          var valueDate = new Date(value);
          var dayIndex = (0, _date.getDayDiff)(valueDate, minTime);

          if (dayIndex >= this.days.length) {
            console.warn('Use "setTime" to set a time exceeded to the option range do not actually work.');
            return;
          } // calculate hourIndex


          var minValueDate = this.columnCount === 3 ? valueDate : new Date(+valueDate + _date.HOUR_TIMESTAMP);
          var hour = minValueDate.getHours();
          var beginHour = dayIndex === 0 ? this.minTime.getHours() : 0;
          var hourIndex = hour - beginHour; // calculate minuteIndex

          var minute = Math.ceil(valueDate.getMinutes() / this.minuteStep);
          var beginMinute = !dayIndex && !hourIndex ? Math.ceil(this.minTime.getMinutes() / this.minuteStep) : 0;
          var minuteIndex = minute - beginMinute;
          return this.columnCount === 3 ? [dayIndex, hourIndex, minuteIndex] : [dayIndex, hourIndex];
        }
      },
      _day: function _day() {
        var defaultDay = {
          filter: ['今天'],
          format: 'M月D日 d',
          step: 5
        };
        return Object.assign({}, defaultDay, this.day);
      },
      minTime: function minTime() {
        var minTimeStamp = +this.min || +this.now;

        if (this.columnCount === 3) {
          var minute = new Date(minTimeStamp).getMinutes();
          var intMinute = Math.min(Math.ceil(minute / this.minuteStep) * this.minuteStep, 60);
          minTimeStamp += (intMinute - minute) * _date.MINUTE_TIMESTAMP;
        } else {
          minTimeStamp += _date.HOUR_TIMESTAMP;
        }

        return new Date(minTimeStamp);
      },
      maxTime: function maxTime() {
        var maxTimeStamp = +this.max || (0, _date.getZeroStamp)(new Date(+this.minTime + this._day.step * _date.DAY_TIMESTAMP)) - 1;
        var minute = new Date(maxTimeStamp).getMinutes();
        var intMinute = Math.floor(minute / this.minuteStep) * this.minuteStep;
        maxTimeStamp -= (minute - intMinute) * _date.MINUTE_TIMESTAMP;
        return new Date(maxTimeStamp);
      },
      days: function days() {
        var days = [];
        var dayDiff = (0, _date.getDayDiff)(this.minTime, this.now);
        var len = this.max ? (0, _date.getDayDiff)(this.maxTime, this.minTime) + 1 : this._day.step;

        for (var i = 0; i < len; i++) {
          var timestamp = +this.minTime + i * _date.DAY_TIMESTAMP;
          var dayText = (0, _date.formatDate)(new Date(timestamp), this._day.format).split(' ');
          days.push({
            value: timestamp,
            text: this._day.filter && this._day.filter[dayDiff + i] || dayText[0],
            unit: dayText[1]
          });
        }

        return days;
      },
      hours: function hours() {
        var hours = [];

        for (var i = 0; i < 24; i++) {
          var hourItem = {
            value: i,
            text: "".concat((0, _date.padZero)(i)),
            unit: '时'
          };

          if (this.columnCount === 3) {
            hourItem.children = this.minutes;
          }

          hours.push(hourItem);
        }

        return hours;
      },
      minutes: function minutes() {
        var minutes = [];

        for (var i = 0; i < 60; i += this.minuteStep) {
          minutes.push({
            value: i,
            text: "".concat((0, _date.padZero)(i)),
            unit: '分'
          });
        }

        return minutes;
      },
      timeData: function timeData() {
        var _this = this;

        var days = this.days.slice();

        if (this.maxTime - this.minTime <= -60000) {
          console.warn('The max is smaller than the min optional time.');
          return [];
        }

        days.forEach(function (day, index) {
          var isMinDay = index === 0;
          var isMaxDay = index === days.length - 1;

          if (!isMinDay && !isMaxDay) {
            day.children = _this.hours;
            return;
          }

          var partHours = [];
          var minHour = isMinDay ? _this.minTime.getHours() : 0;
          var maxHour = isMaxDay ? _this.maxTime.getHours() : 23;

          for (var i = minHour; i <= maxHour; i++) {
            var isMinHour = isMinDay && i === minHour;
            var isMaxHour = isMaxDay && i === maxHour;

            if (!isMinHour && !isMaxHour) {
              var _hourItem = {
                value: i,
                text: "".concat((0, _date.padZero)(i)),
                unit: '时'
              };

              if (_this.columnCount === 3) {
                _hourItem.children = _this.minutes;
              }

              partHours.push(_hourItem);
              continue;
            }

            var start = isMinHour ? Math.round(_this.minTime.getMinutes() / _this.minuteStep) : 0;
            var end = isMaxHour ? Math.round(_this.maxTime.getMinutes() / _this.minuteStep) : Math.floor(59 / _this.minuteStep);

            var partMinutes = _this.minutes.slice(start, end + 1);

            var hourItem = {
              value: i,
              text: "".concat((0, _date.padZero)(i)),
              unit: '时'
            };

            if (_this.columnCount === 3) {
              hourItem.children = partMinutes;
            }

            partHours.push(hourItem);
          }

          day.children = partHours;
        });
        return days;
      }
    },
    methods: {
      $_onShow: function $_onShow() {
        this.$emit('show'); // this.now = new Date()
      },
      _pickerChange: function _pickerChange(i, newIndex) {
        this.$emit('change', i, newIndex);
      },
      _pickerConfirm: function _pickerConfirm(selectedVal, selectedIndex, selectedText) {
        var timestamp = this.columnCount === 3 ? (0, _date.getZeroStamp)(new Date(selectedVal[0])) + selectedVal[1] * _date.HOUR_TIMESTAMP + selectedVal[2] * _date.MINUTE_TIMESTAMP : (0, _date.getZeroStamp)(new Date(selectedVal[0])) + selectedVal[1] * _date.HOUR_TIMESTAMP;
        var text = this.columnCount === 3 ? selectedText[0] + ' ' + selectedText[1] + ':' + selectedText[2] : selectedText[0] + ' ' + selectedText[1];
        this.timeValue = timestamp;
        var formatedTime = (0, _date.formatDate)(new Date(timestamp), this.format);
        this.$emit('confirm', timestamp, text, formatedTime);
      },
      _pickerCancel: function _pickerCancel() {
        this.$emit('cancel');
      },
      $_onInput: function $_onInput(val) {
        this.$emit('input', val);
      },
      unitShowBtn: function unitShowBtn(arr) {
        if (arr.length <= 1) {
          return false;
        }

        var firstUnit = arr[0].unit;

        for (var i = 1; i < arr.length; i++) {
          if (arr[i].unit !== firstUnit) {
            return true;
          }
        }

        return false;
      }
    }
  };
  _exports.default = _default2;
});